import React from "react";
import Typewriter from "typewriter-effect";

const Type = () => {
  return (
    <Typewriter
      options={{
        strings: [
          "Marketing Funnel Strategist",
          "Front end Engineer",
          "Full-Stack Engineer",
          "Web Application Engineer",
          "Mobile Application Engineer"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 50,
      }}
    />
  )
}

export default Type